import { z } from "zod";
import { ZIP_JOB_STATUSES } from "@/lib/enums";
import { photoListQuerySchema } from "@/schemas/photos";

/** One request can name at most this many photos by id; "everything in this filter" has no cap. */
const MAX_PHOTO_IDS = 50_000;

/**
 * `POST /api/zips`. Photos come as a list of ids, as one album, or as a filter, which is how
 * "select all" reaches photos the screen has not loaded. `excludeIds` takes some back out.
 */
export const createZipSchema = z.union([
  z.strictObject({ photoIds: z.array(z.string().min(1)).min(1).max(MAX_PHOTO_IDS) }),
  z.strictObject({ albumId: z.string().min(1) }),
  z.strictObject({
    projectId: z.string().min(1),
    filters: photoListQuerySchema,
    excludeIds: z.array(z.string().min(1)).max(MAX_PHOTO_IDS).optional(),
  }),
]);
export type CreateZipRequest = z.infer<typeof createZipSchema>;

const zipJobSchema = z.object({
  id: z.string(),
  fileName: z.string(),
  status: z.enum(ZIP_JOB_STATUSES),
  doneCount: z.number(),
  /** Photos that are not in the zip. Meaningful once the job is done. */
  missingCount: z.number(),
  totalCount: z.number(),
  error: z.string().nullable(),
  createdAt: z.string(),
});
export type ZipJob = z.infer<typeof zipJobSchema>;

export const zipJobListResponseSchema = z.object({ data: z.array(zipJobSchema) });
export const createZipResponseSchema = z.object({ id: z.string() });
